var App = App || {};

App.Search = (function ($) {
    "use strict";

    const activeClass = "active";
    const siteSearchPrefix = "#site-search-";
    const catalogSearchPrefix = "#catalog-search-";
    const headerSearch = $("#site-header-search");

    const mobileSearch = $("#site-header-search-offcanvas .searches-wrapper")

    function init() {
        //
        //Desktop header search
        //
        var searchSubmits = headerSearch.find("button[type='submit']");
        var searchOption = headerSearch.find("select");

        $(document).ready(function () {
            if (searchOption.val() == "website") {
                switchFieldsets(siteSearchPrefix, catalogSearchPrefix);
            } else {
                switchFieldsets(catalogSearchPrefix, siteSearchPrefix);
            }

            var selectedOption = $("input[name='offcanvas-search-options']:checked")
            if (selectedOption.val() == "website") {
                switchFieldsetsMobile(siteSearchPrefix, catalogSearchPrefix);
            }
            else {
                switchFieldsetsMobile(catalogSearchPrefix, siteSearchPrefix);
            }
        });

        searchOption.on("change", function () {
            if ($(this).val() == "website") {
                switchFieldsets(siteSearchPrefix, catalogSearchPrefix);
            }
            else if ($(this).val() == "online catalog") {
                switchFieldsets(catalogSearchPrefix, siteSearchPrefix);
            }
        });

        searchSubmits.on("click", function (e) {
            if (searchOption.val() != "website") {
                e.preventDefault();
                searchEncore("catalog-search-input");
            }
        });

        //
        // Mobile Search Menu
        //
        var mobileSearchOptions = mobileSearch.find("input[name='offcanvas-search-options']");
        var searchSubmitsMobile = mobileSearch.find("button[type='submit']");

        mobileSearchOptions.on("change", function (e) {
            var selectedOption = $("input[name='offcanvas-search-options']:checked")
            if (selectedOption.val() == "website") {
                switchFieldsetsMobile(siteSearchPrefix, catalogSearchPrefix);
            }
            else {
                switchFieldsetsMobile(catalogSearchPrefix, siteSearchPrefix);
            }
        });

        searchSubmitsMobile.on("click", function (e) {
            var selectedOption = $("input[name='offcanvas-search-options']:checked")
            if (selectedOption.val() != "website") {
                e.preventDefault();
                searchEncore("catalog-search-input-mobile");
            }
        });

        $('#catalogsearch-form').on('submit', function (e) {
            e.preventDefault(); 
            searchEncore('catalog-search-text');
        });
    }

    function switchFieldsets(newPrefix, oldPrefix) {
        headerSearch.find("fieldset").removeClass(activeClass);
        headerSearch.find(newPrefix + "fieldset").addClass(activeClass);
        headerSearch.find(newPrefix + "input").val(headerSearch.find(oldPrefix + "input").val());
    }

    function switchFieldsetsMobile(newPrefix, oldPrefix) {
        mobileSearch.find("fieldset").removeClass(activeClass);
        mobileSearch.find(newPrefix + "fieldset-mobile").addClass(activeClass);
        mobileSearch.find(newPrefix + "input-mobile").val(headerSearch.find(oldPrefix + "input-mobile").val());
    }

    /**
     * Search Box / Search Options Functionality
     * (largely copied from previous site)
     */
    function searchEncore(inputId) {
        var encoreBaseURLInput = "https://encore.socialaw.com/iii/encore/search/",
            encoreBaseURL,
            searchInput = document.getElementById(inputId),
            scopeInput = document.getElementById('encoreSearchLocation'),
            languageSetting = document.getElementById("encoreLanguage"),
            searchString,
            scopeString = "__Lf:facetcollections:2:2:SLL::",
            locationHref,
            charRegExString,
            base64Regex;

        /*
        base64_encoding_map includes special characters that need to be encoded using base64.
        these chars are "=","/", "\", "?" character : base64 encoded 
        */
        var base64_encoding_map = { "=": "PQ==", "/": "Lw==", "\\": "XA==", "?": "Pw==" };

        var escapeRegExp = function (string) {
            return string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        }

        if (searchInput && encoreBaseURLInput) {
            encoreBaseURL = encoreBaseURLInput;
            searchString = searchInput.value;

            if (!searchString) {
                return false;
            }

            for (var specialChar in base64_encoding_map) {
                charRegExString = escapeRegExp(specialChar);
                base64Regex = new RegExp(charRegExString, "g");
                searchString = searchString.replace(base64Regex, base64_encoding_map[specialChar])
            }
            searchString = encodeURIComponent(searchString);

            if (scopeInput) {
                scopeString = scopeInput.value;
            }

            if (scopeString) {
                scopeString = encodeURIComponent(scopeString);
                locationHref = encoreBaseURL + "C__S" + searchString + scopeString + "__Orightresult__U";
            } else {
                locationHref = encoreBaseURL + "C__S" + searchString + "__Orightresult__U";
            }

            if (languageSetting) {
                locationHref = locationHref + "?lang=" + languageSetting.value;
            }

            window.open(locationHref, "_blank");
        }
        return false;
    }

    return {
        init: init,
        searchEncore: searchEncore
    };

})(jQuery);

$(function () {
    App.Search.init();
});